import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { getUrl, getPhienBan, getDomain } from "utils/utils";

import { Index_GetConfigAllSTKey } from "actions/DanhMuc/";
import configs from "constants/configs";

const SidebarLink = styled(Link)`
  font-family: "Roboto-Regular";
  display: flex;
  color: #ffffff;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  list-style: none;
  text-decoration: none;
  font-size: 14px;

  &:hover {
    background: #0056b8;
    cursor: pointer;
    color: #ffffff;
    text-decoration: none;
  }
  &:active {
    background: #0056b8;
    cursor: pointer;
    color: #ffffff;
    text-decoration: none;
  }
  &:visited {
    background: #0056b8;
    cursor: pointer;
    color: #ffffff;
    text-decoration: none;
  }
`;

const SidebarLabel = styled.span`
  margin-left: 16px;
`;

const SidebarLabelBold = styled.span`
  margin-left: 16px;
  font-family: "Roboto Medium";
  color: #fff;
`;

const DropdownLink = styled(Link)`
  font-family: "Roboto-Regular";
  background: #0056b8;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 3rem;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #f5f5f5;
  font-size: 14px;

  &:hover {
    background: #0056b8;
    cursor: pointer;
    color: #ffffff;
    text-decoration: none;
  }
  &:active {
    background: #0056b8;
    cursor: pointer;
    color: #ffffff;
    text-decoration: none;
  }
  &:visited {
    background: #0056b8;
    cursor: pointer;
    color: #ffffff;
    text-decoration: none;
  }
`;

const SubMenu = ({ item }) => {
  const [subnav, setSubnav] = useState(false);

  const showSubnav = () => setSubnav(!subnav);

  // lấy cấu hình phiên bản nếu value = DoanhNghiepFull thì show Duyệt yêu cầu
  const initData = {
    configPhienBan: "",
  };

  const [dataMenu, setDataMenu] = useState(initData);
  // const dispatch = useDispatch();
  // useEffect(() => {
  //   debugger
  //   //gọi cấu hình
  //   dispatch(Index_GetConfigAllSTKey());
  //   //End gọi cấu hình
  // }, []);

  // const danhmuc = useSelector((state) => state.danhmuc);
  // const { objConfigAll } = danhmuc;
  // var configPhienBan = objConfigAll.List.find(
  //   (e) => e.KeyID.toUpperCase() === configs.sKey.KeyPhienBan.toUpperCase()
  // );

  // if (
  //   typeof configPhienBan !== "undefined" &&
  //   configPhienBan != null &&
  //   configPhienBan.Value &&
  //   configPhienBan.Value != dataMenu.configPhienBan
  // ) {
  //   const thongtin = { ...dataMenu };
  //   thongtin.configPhienBan = configPhienBan.Value;
  //   setDataMenu(thongtin);
  // }
  return (
    <>
          {item.isShow !== false && (
            <>
              <a
                className="SidebarLink"
                href={item.path}
                onClick={item.subNav && showSubnav}
              >
                <div>
                  <img src={item.icon} className="icon-menu-new"></img>

                  {item.textBold === "" ? (
                    <SidebarLabelBold>{item.title}</SidebarLabelBold>
                  ) : (
                    <SidebarLabel>{item.title}</SidebarLabel>
                  )}
                </div>
                <div>
                  {subnav ? (
                    <img src={item.iconOpened}></img>
                  ) : item.subNav ? (
                    <img src={item.iconClosed}></img>
                  ) : null}
                </div>
              </a>
              {subnav &&
                item.subNav.map((item, index) => {
                  return (
                    <a className="DropdownLink" href={item.path} key={index}>
                      <img src={item.icon}></img>
                      <SidebarLabel>{item.title}</SidebarLabel>
                    </a>
                  );
                })}
            </>
          )}
        </>
  );
};

export default SubMenu;
